import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

import { LMLoggerService } from './lm-logger.service';
import { LMManualRepresentationComponent } from '@field/index';

@Injectable()
export class LMHtmlUrlDocService {

  public identifier = 0;
  private framesRef: LMHtmlUrlDocRef = {};

  constructor(
    private lmLoggerService: LMLoggerService,
  ) {}

  public createFrameIdentifier(): string {
    const frameId = 'frameId' + this.identifier++;
    this.framesRef[frameId] = {};
    return frameId;
  }

  public getFrameRefs(): LMHtmlUrlDocRef {
    return this.framesRef;
  }

  public setManualFields(indentifier: string, manualRepFields: {}, manRepComp: LMManualRepresentationComponent) {
    this.framesRef[indentifier] = {manualRepFields: manualRepFields, compRef: manRepComp};
  }

  public getFrameData(identifier: string): LMHtmlUrlDocData {
    return this.framesRef[identifier];
  }

  private handleError(error: Response) {
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }

  public getManualRefCompRef(identifier: string): LMManualRepresentationComponent {
      const ref = this.framesRef[ identifier ];
      return ref.compRef;
  }

  public getManualRefCompRefs(): LMManualRepresentationComponent[] {
    const keys: string[] = Object.keys(this.framesRef);
    let returnCompRef = [];
    for (let key of keys) {
      const ref = this.framesRef[ key ];
      returnCompRef.push(ref.compRef);
    }
    return returnCompRef;
  }
}
